import { useAuth } from '@clerk/clerk-react';
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { FullPageSpinner } from '@/components/ui/full-page-spinner';

export const Route = createFileRoute('/_public/')({
  beforeLoad: async ({ context }) => {
    if (context.auth.isLoading) {
      // Clerk is still loading — render the component and wait
      return;
    }
    if (context.auth.isAuthenticated) {
      throw redirect({ to: '/sequences' });
    }
    throw redirect({ to: '/login' });
  },
  component: RootRedirect,
});

/**
 * Shown only while Clerk is loading. Once loading completes, redirects to
 * /sequences or /login.
 */
function RootRedirect() {
  const { isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoaded) return;
    navigate({ to: isSignedIn ? '/sequences' : '/login', replace: true });
  }, [isLoaded, isSignedIn, navigate]);

  return <FullPageSpinner />;
}
